import { render, staticRenderFns } from "./App.vue?vue&type=template&id=28e0e08a"
import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./App.vue?vue&type=style&index=0&id=28e0e08a&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports